import NotFound from "presentation/components/Shared/NotFound";
import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";

const Timesheet = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div>
      <FunctionHeader title="Em desenvolvimento" />
      <NotFound />
    </div>
  );
};

export default Timesheet;
